import { defineComponent as t, computed as p, openBlock as r, createBlock as c, unref as s } from "vue";
import a from "../assets/icons/spinner.svg.mjs";
const u = /* @__PURE__ */ t({
  __name: "spinner-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, i = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, o = p(() => i[l.size]);
    return (n, d) => (r(), c(s(a), {
      fill: n.fill,
      width: o.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=spinner-icon.vue.mjs.map
